var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { CompletedStep, ProcessStep, LookupVehicle } from 'Components.Structure';
import { Button } from 'Components.Form';
import { CommissioningApi } from 'Api';
import { injectIntl, FormattedMessage } from 'Intl';
var NewVehicleContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: .3rem;\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n"], ["\n  margin-bottom: .3rem;\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n"])));
var SearchCreateDivider = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: .5rem;\n  display: flex;\n  justify-content: center;\n"], ["\n  margin: .5rem;\n  display: flex;\n  justify-content: center;\n"])));
var FindVehicleProcessStep = /** @class */ (function (_super) {
    __extends(FindVehicleProcessStep, _super);
    function FindVehicleProcessStep(props) {
        var _this = _super.call(this, props) || this;
        _this.setConfirmed = function (confirmed) {
            _this.setState({
                confirmed: confirmed,
            });
        };
        _this.setSelectedVehicle = function (selectedVehicle) {
            _this.setState({
                selectedVehicle: selectedVehicle,
            });
        };
        _this.handleSearch = function (type, input) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ selectedVehicle: null });
                        return [4 /*yield*/, this.commissioningApi.lookupVehicle(type === 'vrn' ? { vrn: input } : { vin: input })];
                    case 1:
                        result = _a.sent();
                        if (result.status === 204) {
                            return [2 /*return*/, { error: this.props.intl.formatMessage('errorCode.COM-04-002') }];
                        }
                        if (result.isSuccess && result.payload) {
                            return [2 /*return*/, { vehicle: result.payload }];
                        }
                        if (result.errorCode) {
                            // Unique error code handling for specific commissioning errors
                            if (result.errorCode === 1001) {
                                return [2 /*return*/, { error: this.props.intl.formatMessage('errorCode.COM-04-001') }];
                            }
                            return [2 /*return*/, { error: this.props.intl.formatMessage("errorCode.".concat(result.errorCode)) }];
                        }
                        return [2 /*return*/, { error: this.props.intl.formatMessage('lookupVehicle.genericError') }];
                }
            });
        }); };
        _this.state = {
            selectedVehicle: null,
            confirmed: false,
        };
        _this.commissioningApi = new CommissioningApi();
        return _this;
    }
    FindVehicleProcessStep.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this.state, confirmed = _c.confirmed, selectedVehicle = _c.selectedVehicle;
        var _d = this.props, label = _d.label, loading = _d.loading, vehicle = _d.vehicle, createNew = _d.createNew, baseId = _d.baseId, intl = _d.intl;
        return (React.createElement(ProcessStep, { baseId: baseId, confirmed: confirmed, label: label, subtitle: intl.formatMessage('findVehicle.description'), loading: loading, confirmDisabled: selectedVehicle == null, onEditStep: function () {
                _this.props.onEdit();
                _this.setConfirmed(!confirmed);
                _this.setSelectedVehicle(null);
            }, onConfirm: function () {
                if (selectedVehicle == null)
                    return;
                _this.setConfirmed(!confirmed);
                _this.props.onConfirm({
                    createNew: false,
                    vehicle: selectedVehicle.value,
                });
            }, confirmedContent: (React.createElement(React.Fragment, null, (vehicle != null || createNew != null) && (React.createElement(CompletedStep, { title: createNew
                    ? intl.formatMessage('findVehicle.newVehicle')
                    : (vehicle ? vehicle.vrn : ''), subtitle: createNew
                    ? intl.formatMessage('findVehicle.newVehicleDescription')
                    : (vehicle ? "".concat(vehicle.make, " - ").concat(vehicle.model) : '') })))), activeContent: (React.createElement(LookupVehicle, { baseId: baseId, selectedVehicle: (_b = (_a = this.state.selectedVehicle) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null, onLookup: this.handleSearch, onVehicleFound: function (vehicle) {
                    var _a;
                    return _this.setState({
                        selectedVehicle: { label: (_a = vehicle.vrn) !== null && _a !== void 0 ? _a : '', value: vehicle }
                    });
                } })), extraActiveContent: (React.createElement(NewVehicleContainer, null,
                React.createElement(SearchCreateDivider, null, " or "),
                React.createElement(Button, { id: "".concat(baseId, "_newVehicle_button"), success: true, onClick: function () {
                        _this.setConfirmed(true);
                        _this.setSelectedVehicle(null);
                        _this.props.onConfirm({
                            createNew: true,
                            vehicle: null,
                        });
                    } },
                    React.createElement(FormattedMessage, { id: 'findVehicle.newVehicle' })))) }));
    };
    return FindVehicleProcessStep;
}(React.Component));
export default injectIntl(FindVehicleProcessStep);
var templateObject_1, templateObject_2;
